export const getCurrentLocale = () => {
  const browserLanguage =
    typeof navigator !== "undefined" && typeof navigator.language === "string"
      ? navigator.language
      : null;
  const defaultLocale = ["nn-NO", "nb-NO", "nb"].includes(browserLanguage || "")
    ? "nb"
    : "en";
  const preferredLocale =
    typeof window !== "undefined" &&
    typeof window.localStorage?.getItem === "function"
      ? window.localStorage.getItem("language.preference")
      : null;

  return preferredLocale || defaultLocale;
};
